<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-1">
      {{ $t("mp:application.closed.title") }}
    </p>
    <application-template
      template="MERCHANT_APPLICATION_CLOSED"
    ></application-template>
    <b-button type="is-blue" class="mt-6" @click="reset">{{
      $t("mp:application.closed.button.back_to_preliminary")
    }}</b-button>
  </div>
</template>

<script>
export default {
  name: "ApplicationFlowClosed",
  components: {
    ApplicationTemplate: () =>
      import("@/components/application/ApplicationTemplate.vue"),
  },
  props: {},
  computed: {},
  methods: {
    reset() {},
  },
};
</script>

<style scoped lang="scss"></style>
